__webpack_require__.p = "https://manviag.personal.dynamic-ads.video.amazon.dev/";